import React from "react";

const Search = ({ color, height, width }) => (
  <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.6257 7.31143C14.6257 8.92486 14.1019 10.4153 13.2194 11.6245L17.6704 16.0781C18.1099 16.5175 18.1099 17.2311 17.6704 17.6705C17.2309 18.1098 16.5172 18.1098 16.0777 17.6705L11.6267 13.2168C10.4173 14.0991 8.92661 14.6229 7.31286 14.6229C3.27321 14.6229 0 11.3503 0 7.31143C0 3.27257 3.27321 0 7.31286 0C11.3525 0 14.6257 3.27257 14.6257 7.31143ZM7.31286 12.3732C10.1079 12.3732 12.3756 10.1059 12.3756 7.31143C12.3756 4.51692 10.1079 2.24967 7.31286 2.24967C4.5178 2.24967 2.25011 4.51692 2.25011 7.31143C2.25011 10.1059 4.5178 12.3732 7.31286 12.3732Z"
      fill={color}
    />
  </svg>
);

Search.defaultProps = {
  width: 28,
  height: 28,
  color: "white"
};

export default Search;
